export const listDomainNames = `
   query listDomainNames($filter: DomainNamesFilterInput, $limit:Int, $nextToken:String) {
       listDomainNames(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
              tldId
              topLevelDomain {
                 id
                 name
              }
              category
              purchaseDate
              expirationDate
              registrarId
              registrar {
                 id
                 name
              }
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getDomainName = `
   query getDomainName($id:ID!) {
       getDomainName(id:$id) {
          id
          name
          tldId
          topLevelDomain {
             id
             name
          }
          category
          purchaseDate
          expirationDate
          registrarId
          registrar {
             id
             name
          }
          createdByUsername
          created
          updated
      } 
}`;

export const lookupHostname = `
   query lookupHostname($hostname:String!) {
       lookupHostname(hostname:$hostname) {
          address
          family
      } 
}`;
